import React, {useEffect, useState} from 'react'

import {Col, Container, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'

import KurzyLayout from './KurzyLayout'
import amaniCoffe from '../assets/amani-coffee.png'
import {useContentWrapper} from '../common/ContentWrapperProvider'
import {money} from '../common/helpers'
import {StyledInfoPageHeaderWrapper} from '../common/styledComponents'
import axios from '../service/axiosClient'
import {OrderItemCategory} from '../types/OrderItemCategory'
import {OrderItemDto} from '../types/OrderItemDto'


function PriKavickePage() {
    const contentWrapper = useContentWrapper()
    const [products, setProducts] = useState<OrderItemDto[]>([])
    const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set())
    const navigate = useNavigate()

    useEffect(() => {
        axios.get('/order-item/' + OrderItemCategory.PRI_KAVICKE, {}).then(response => {
            console.log('mame data', response.data)
            setProducts(response.data)
        }).catch(error => {
            console.log('error', error)
        })


        contentWrapper.setNoBootstrapColumns(true)

        return () => {
            contentWrapper.setNoBootstrapColumns(false)
        }
    }, [])

    const handleProductSelect = (item: OrderItemDto) => {
        localStorage.setItem('selectedProduct', JSON.stringify(item))
        navigate('/kurzy-pokladna')
    }

    return (
        <KurzyLayout>
            <StyledInfoPageHeaderWrapper>
                <Container>
                    <Row>
                        <Col>
                            <h1 className={'font-vollkorn fs-55 color-pink-primary'}>Pri kávičke</h1>
                        </Col>
                    </Row>
                </Container>

            </StyledInfoPageHeaderWrapper>
            <Container>

                <Row>
                    <Col>
                        {products.map((item) => (<div key={item.id} className="rounded-content-body mt-3 text-pink-dark">

                            {expandedItems.has(item.id) ? (
                                <>
                                    <div dangerouslySetInnerHTML={{__html: item.moreInfo || ''}}/>
                                    <div className={'d-flex justify-content-center mt-3'}>
                                        <button
                                            onClick={() => handleProductSelect(item)}
                                            className="btn btn-primary bg-pink-dark btn-amani w-100 d-inline-block text-uppercase">
                                            chcem kúpiť
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div dangerouslySetInnerHTML={{__html: item.description}}/>
                                    {
                                    /**
                                    <br/><br/>
                                    <strong><span className={'font-vollkorn kurziva'}>Čo ťa tu čaká:</span></strong>
                                    <div dangerouslySetInnerHTML={{__html: item.agenda}}/>
                                    */
                                    }
                                    <br/><br/>
                                    Dátum: <strong className={'text-pink-dark'}>{item.date}</strong><br/>
                                    Čas: <span className={'text-pink-dark'}>{item.time}</span><br/>
                                    Miesto: <span className={'text-pink-dark'}>{item.location}</span><br/>
                                    Cena: <strong className={'text-pink-dark'}>{item.price ? money.format(item.price) : 'bezplatne'}</strong>{item.installmentBuying && ' (možnosť úhrady na 3 splátky)'}

                                    {item.moreInfo ? (
                                        <div className={'d-flex justify-content-center mt-3'}>
                                            <button
                                                onClick={() => setExpandedItems(prev => new Set(prev).add(item.id))}
                                                className="btn btn-primary bg-pink-dark btn-amani w-100 d-inline-block text-uppercase">
                                                viac informácií
                                            </button>
                                        </div>
                                    ) : (
                                        <div className={'d-flex justify-content-end mt-2'}>
                                            <button
                                                onClick={() => handleProductSelect(item)}
                                                className="btn btn-primary bg-pink-dark btn-amani w-auto d-inline-block text-uppercase">
                                                idem na kávičku
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}

                        </div>))}

                    </Col>
                    <Col md={'6'} className={'align-items-end d-flex'}>

                        <img src={amaniCoffe} className="w100p img-hor-vert"/>

                    </Col>
                </Row>

            </Container>
        </KurzyLayout>
    )
}


export default PriKavickePage